"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateComponentsInHUD = exports.default = exports.addBrandingInHUD = void 0;
var _ServiceRegistry = _interopRequireDefault(require("../../../util/ServiceRegistry"));
var _Branding = _interopRequireDefault(require("../header/presentation/branding/Branding"));
var _ViewMode = _interopRequireDefault(require("../../../constants/ViewMode"));
var _AppUtil = require("../../../util/AppUtil");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

const addBrandingInHUD = () => {
  const appStore = _ServiceRegistry.default.getService("AppStore");
  if (appStore.enableModernViewer && appStore.isSizedPreset && !(appStore.showFullScreenModal || (0, _AppUtil.isMobileBrowser)())) {
    appStore.previewRef.getPublicApis().then(apis => {
      apis.document.setViewMode(_ViewMode.default.SINGLE_PAGE);
      apis.hud.addUIControl(_Branding.default, "LEFT");
    });
  }
};
exports.addBrandingInHUD = addBrandingInHUD;
const updateComponentsInHUD = () => {
  const appStore = _ServiceRegistry.default.getService("AppStore");
  const configStore = appStore.configStore;
  if (appStore.enableModernViewer && appStore.isSizedPreset) {
    appStore.previewRef.getPublicApis().then(apis => {
      if (!configStore.getActionConfig("preview").dockPageControls) {
        apis.hud.dock(false);
      }
      if (!configStore.showDownload) {
        apis.app.customizeUIControl("DOWNLOAD", {
          visible: false
        });
      }
      if (!configStore.showPrint) {
        apis.app.customizeUIControl("PRINT", {
          visible: false
        });
      }
    });
  }
};
exports.updateComponentsInHUD = updateComponentsInHUD;
var _default = exports.default = {
  addBrandingInHUD,
  updateComponentsInHUD
};